import {StockInListComponent} from './stock-in-list.component'

export default StockInListComponent
